<template>
  <validation-provider
    #default="{ errors }"
    :name="defaultName"
    mode="passive"
    :rules="rules"
  >
    <b-form-group :label="label" :label-for="id">
      <b-form-file
        browse-text="تصفح"
        :state="$attrs.state || errors.length > 0 ? false : null"
        :name="name"
        :id="id"
        v-bind="$attrs"
        v-on="$listeners"
        @input="onInput"
        :value="value"
      />
      <small class="text-danger">{{ errors[0] }}</small>
    </b-form-group>
  </validation-provider>
</template>
<script>
import { ValidationProvider } from "vee-validate";
import { BFormGroup, BFormFile } from "bootstrap-vue";
import {
  required,
  email,
  confirmed,
  url,
  between,
  alpha,
  integer,
  password,
  min,
  digits,
  alphaDash,
  length,
} from "@validations";
import SizeValidationMixin from "@/utils/mixins/file-size-validation";
export default {
  components: {
    ValidationProvider,
    BFormGroup,
    BFormFile,
  },
  mixins: [SizeValidationMixin],
  props: {
    id: {
      type: String,
      default: () => "input",
    },
    value: {
      type: File,
    },
    name: {
      type: String,
    },
    rules: {
      type: String,
      default: () => "",
    },
    label: {
      type: String,
      default: () => "",
    },
    description: {
      type: String,
      default: () => "",
    },
  },
  data() {
    return {
      required,
      email,
      confirmed,
      url,
      between,
      alpha,
      integer,
      password,
      min,
      digits,
      alphaDash,
      length,
    };
  },
  computed: {
    defaultName() {
      return this.name || this.label;
    },
  },
  methods: {
    onInput(e) {
      this.validateFileSize(e)
        .then(() => {
          this.$emit("input", e);
        })
        .catch(() => {
          this.$emit("input", null);
          this.$bvModal.msgBoxOk("حجم الملف يتجاوز حد الحجم المسموح !", {
            size: "sm",
            okVariant: "danger",
            okTitle: "حسناً",
            hideHeaderClose: false,
            centered: true,
          });
        });
    },
  },
};
</script>
<style lang="css">
.custom-file-input:lang(en) ~ .custom-file-label::after {
  content: "تصفح";
}
</style>
